import { defineMessages } from 'react-intl';

export const messages: {
	noFilterTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noResultsTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noResultsTitle: {
		id: 'company-hub.cards-extension.dynamic-card-empty-state.no-results-title',
		defaultMessage: 'Nothing yet. Check back soon.',
		description:
			'Placeholder title that is displayed in card when there are no results given the current filters',
	},
	noFilterTitle: {
		id: 'company-hub.cards-extension.dynamic-card-empty-state.no-filter-title',
		defaultMessage: 'Add filters to populate cards.',
		description:
			'Placeholder title when there are no filters applied in card, prompting users to add filters to see results',
	},
});
